import { useEffect } from 'react'
import DashboardChat from '../../components/CommonComponents/DashboardChat/DashboardChat';
import { useLocation, useNavigate } from 'react-router-dom';
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';

const ChatListPage = () => {
  const state = useLocation().state;
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "GenieGig | Your Chats";
    logAnalyticsEvent(GGAnalyticsEvents.MY_MESSAGES_PAGE_LOADED);
  })

  const handleBackClick = () => {
    // Navigate back or go to home
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <DashboardChat
      {...(state?.channelId && { initialSelectedChannel: state.channelId })}
      onHeaderBackClick={handleBackClick}
    />
  );
}

export default ChatListPage